import { NavigationExtras } from '@angular/router';
import { Option } from '@sapphire/result';
import { Survey, SurveyKind } from '@ps/survey-utils';
import { Nullable } from '@ps/utils';

import { SurveyChildKey } from '../../survey-creation-shared-state.model';

/** The navigation-state key the target page's resolver reads the child from. */
export const ACTIVE_CHILD_KEY_STATE = 'activeChildKey';

// Only a project has a child of its own to carry into the next page; any
// other survey's page is already keyed by its route.
export function activeChildNavigationExtras(
  survey: Survey,
  activeChildKey: Nullable<SurveyChildKey>,
): NavigationExtras {
  return Option.from(activeChildKey)
    .filter(() => SurveyKind.isProject(survey))
    .mapOr({}, (key) => ({ state: { [ACTIVE_CHILD_KEY_STATE]: key } }));
}
